import { render } from "./CreateOrganization.vue?vue&type=template&id=1d3c317a"
import script from "./CreateOrganization.vue?vue&type=script&lang=js"
export * from "./CreateOrganization.vue?vue&type=script&lang=js"

import "./CreateOrganization.vue?vue&type=style&index=0&id=1d3c317a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__